import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '3.5rem',
        fontWeight: theme.typography.fontWeightRegular,
    },
    date: {
        paddingLeft: '2px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },
}));
